import React, { useState, useEffect } from "react";

const ContactModal = ({ open, onClose, source, title, intro }) => {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState({ firma: "", name: "", email: "", telefon: "" });

  useEffect(() => {
    if (!open) {
      setSubmitted(false);
      setSubmitting(false);
      setError(null);
      setData({ firma: "", name: "", email: "", telefon: "" });
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    if (!data.email && !data.telefon) {
      setError("Bitte E-Mail oder Telefon angeben — damit wir uns zurückmelden können.");
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      const topic = source ? "Beratung Login: " + source : "Beratung Login";
      const payload = {
        data: {
          Topic: topic,
          Firma: data.firma,
          Name: data.name,
          Email: data.email,
          Telefon: data.telefon,
          Nachricht:
            "Beratungs-Anfrage von der Login-Seite (Bestandskunde).\n" +
            "Thema: " + (source || "Allgemein") + "\n" +
            "Firma: " + data.firma + "\n" +
            "Name: " + data.name + "\n" +
            "E-Mail: " + (data.email || "—") + "\n" +
            "Telefon: " + (data.telefon || "—"),
        },
      };
      const res = await fetch("https://api.creditreform-luzern.ch/api/tests", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error("Status " + res.status);
      setSubmitted(true);
    } catch (err) {
      setError(
        "Konnte die Anfrage nicht senden. Bitte direkt an vk@luzern.creditreform.ch oder telefonisch unter +41 41 370 19 44."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1050,
        padding: "1rem",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-3 shadow"
        style={{
          maxWidth: "500px",
          width: "100%",
          padding: "2rem",
          maxHeight: "90vh",
          overflowY: "auto",
          position: "relative",
        }}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Schliessen"
          style={{
            position: "absolute",
            top: "0.75rem",
            right: "1rem",
            border: "none",
            background: "transparent",
            fontSize: "1.6rem",
            lineHeight: 1,
            cursor: "pointer",
            color: "#888",
          }}
        >
          ×
        </button>

        {!submitted ? (
          <>
            <h4 className="text-info fw-bold fs-5 mb-2">{title || "Beratung anfragen"}</h4>
            <p className="text-secondary fw-light mb-4" style={{ fontSize: "0.92rem" }}>
              {intro ||
                "Kurze Anfrage, wir melden uns innerhalb von 24 Stunden bei Ihnen zurück."}
            </p>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Firma*"
                  required
                  value={data.firma}
                  onChange={(e) => setData({ ...data, firma: e.target.value })}
                />
              </div>
              <div className="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name*"
                  required
                  value={data.name}
                  onChange={(e) => setData({ ...data, name: e.target.value })}
                />
              </div>
              <div className="mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="E-Mail"
                  value={data.email}
                  onChange={(e) => setData({ ...data, email: e.target.value })}
                />
              </div>
              <div className="mb-3">
                <input
                  type="tel"
                  className="form-control"
                  placeholder="Telefon"
                  value={data.telefon}
                  onChange={(e) => setData({ ...data, telefon: e.target.value })}
                />
              </div>
              <p
                className="text-secondary fw-light mb-3"
                style={{ fontSize: "0.78rem" }}
              >
                Bitte E-Mail oder Telefon angeben. * Pflichtfeld.
              </p>
              {error && (
                <p
                  className="text-danger fw-light mb-3"
                  style={{ fontSize: "0.85rem" }}
                >
                  {error}
                </p>
              )}
              <button
                type="submit"
                className="btn fw-bold rounded-3 text-white"
                style={{
                  backgroundColor: "#1976D2",
                  border: "none",
                  padding: "0.5rem 1.25rem",
                }}
                disabled={submitting}
              >
                {submitting ? "Sende ..." : "Anfrage senden"}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center py-3">
            <h4 className="text-info fw-bold fs-5 mb-2">Anfrage angekommen.</h4>
            <p className="text-secondary fw-light mb-4">
              Wir melden uns innerhalb von 24 Stunden bei Ihnen zurück.
            </p>
            <button
              type="button"
              onClick={onClose}
              className="btn fw-bold rounded-3 text-white"
              style={{
                backgroundColor: "#1976D2",
                border: "none",
                padding: "0.5rem 1.25rem",
              }}
            >
              Schliessen
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactModal;
